import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6149d124"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "payment_explanation_item"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "payment_explanation_details"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 2,
  class: "payment_explanation_diagnostics"
}
const _hoisted_8 = { class: "payment_explanation_diagnostics_header" }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: "payment_explanation",
    onClick: _cache[0] || (_cache[0] = $event => (_ctx.onExplanationClick($event)))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.explanation.items, (item) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: item.orderItemId
      }, [
        (item.summary || item.details.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (item.summary)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "payment_explanation_summary",
                    innerHTML: _ctx.renderPart(item.summary)
                  }, null, 8, _hoisted_2))
                : _createCommentVNode("", true),
              (item.details.length > 0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.details, (detail, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        innerHTML: _ctx.renderPart(detail)
                      }, null, 8, _hoisted_4))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    (_ctx.explanation.totalCalculation)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "payment_explanation_total",
          innerHTML: _ctx.renderPart(_ctx.explanation.totalCalculation)
        }, null, 8, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.explanation.dateExplanation)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: "payment_explanation_date",
          innerHTML: _ctx.renderPart(_ctx.explanation.dateExplanation)
        }, null, 8, _hoisted_6))
      : _createCommentVNode("", true),
    (_ctx.explanation.diagnostics && _ctx.explanation.diagnostics.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t('order.diagnostics.header')), 1),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.explanation.diagnostics, (part, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                innerHTML: _ctx.renderPart(part)
              }, null, 8, _hoisted_9))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}